import { z } from 'zod';
import { PAYMENT_FILE_ROW_FAILURE_CODE } from './file-processing.js';
import { ROW_PROCESSING_STATUS } from './row-processing-status.js';
/** Runtime validator for payment-file row `failure_code` (derived from shared `PAYMENT_FILE_ROW_FAILURE_CODE`). */
export const PaymentFileRowFailureCodeSchema = z.nativeEnum(PAYMENT_FILE_ROW_FAILURE_CODE);
/** Runtime validator for per-row `status` on persisted payment file row results. */
export const PaymentFileRowProcessingStatusSchema = z.nativeEnum(ROW_PROCESSING_STATUS);
//# sourceMappingURL=payment-file-row-result.schema.js.map